import { BookingRewireDataType } from "../../../Models/BookingRewireDataType";
import { RootStore } from "../../../reducers";

const isUserCreatorParticipantOrAdmin = (user: RootStore["user"], booking: BookingRewireDataType) => {
  const normalize = (value?: string | null) => value?.trim().toLowerCase();
  const actorId = (user as { user?: string }).user ?? user.id;
  const isCreator = booking.createdBy === actorId;
  const userEmail = normalize(user.email);
  const isParticipant = !!userEmail && booking.reservedForEmails?.some(
    (participant) => normalize(participant) === userEmail,
  );
  const isAdmin = user.roles?.includes("BookingAdmin");
  return isCreator || isParticipant || isAdmin;
};

export default isUserCreatorParticipantOrAdmin;